export const PAYMENT_METHOD_LABELS: Record<string, string> = {
  // acss_debit: "ACSS Debit (Canada)",
  // affirm: "Affirm",
  // afterpay_clearpay: "Afterpay/Clearpay",
  // alipay: "Alipay",
  // amazon_pay: "Amazon Pay",
  // apple_pay: "Apple Pay",
  // bacs_debit: "BACS Debit (UK)",
  // bancontact: "Bancontact",
  // blik: "BLIK",
  card: "Card",
  // cartes_bancaires: "Cartes Bancaires",
  // cashapp: "Cash App",
  customer_balance: "Customer Balance",
  // eps: "EPS",
  // giropay: "Giropay",
  // google_pay: "Google Pay",
  // ideal: "iDEAL",
  // klarna: "Klarna",
  // link: "Stripe Link",
  // multibanco: "Multibanco",
  // p24: "Przelewy24 (P24)",
  // paypal: "PayPal",
  // sepa_debit: "SEPA Direct Debit",
  // sofort: "Sofort",
  us_bank_account: "ACH (US Bank Account)",
  // wechat_pay: "WeChat Pay",
  // zip: "Zip (Buy Now, Pay Later)",
};

export const PAYMENT_METHOD_CURRENCY_SUPPORT: Record<string, string[]> = {
  // Universal or very broad support
  card: ["*"],
  // link: ["*"],
  customer_balance: ["*"],

  // Bank debits / region-specific methods
  us_bank_account: ["usd"],
  // sepa_debit: ["eur"],
  // acss_debit: ["cad"],
  // bacs_debit: ["gbp"],

  // Buy now, pay later
  // klarna: ["usd", "eur", "gbp", "sek", "nok", "dkk"],
  // afterpay_clearpay: ["aud", "nzd", "gbp", "usd"],
  // affirm: ["usd"],
  // zip: ["aud"],

  // Wallets
  // apple_pay: ["*"], // via card
  // google_pay: ["*"], // via card
  // cashapp: ["usd"],
  // amazon_pay: ["usd", "eur", "gbp"],
  // alipay: ["cny", "usd"], // mainly CNY
  // wechat_pay: ["cny", "hkd", "usd"],

  // Bank redirects
  // bancontact: ["eur"],
  // ideal: ["eur"],
  // sofort: ["eur"],
  // p24: ["eur"],
  // eps: ["eur"],
  // giropay: ["eur"],
  // multibanco: ["eur"],

  // // Regional cards
  // cartes_bancaires: ["eur"],
};

/**
 * Filters payment methods based on the selected currency
 * @param methods Available payment methods
 * @param currency Selected currency (lowercase)
 * @returns Filtered payment methods that support the selected currency
 */
export const filterPaymentMethodsByCurrency = (
  methods: string[],
  currency: string
): string[] => {
  return methods.filter((method) => {
    const supportedCurrencies = PAYMENT_METHOD_CURRENCY_SUPPORT[method] || [];
    return (
      supportedCurrencies.includes("*") ||
      supportedCurrencies.includes(currency.toLowerCase())
    );
  });
};
